var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 94,
    height: 94,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF4AAABeAQMAAACQHDEtAAAAAXNSR0IB2cksfwAAAAZQTFRFAAAABWNjOcdzogAAAAJ0Uk5TAP9bkSK1AAACLklEQVR4nHWUQY7aQBBFXY0lW0okOycwnGAuEKlhlXPMEbIcKVHbSi7CEVjOAgWkXAApGxZR8JIFyrAYBRRw59dvYzvRxALbr9td1V31qyTCNbpEok/e7Co6py1Ic3vBP3vCbT0NgK+i6JgH8LruGhNgqzWFX3IiVKVCsSPUYwW78gbrYAHgSgwWO7gVNYbPRxdMC/yrVQzhFWPcl11VpcAylqjN9VSwMyyJOCYYknAmBfvF0Kk/5hK5jzHBPaSiN4JdxqLThOJ7LNLQMs770wD0wDy8yOhCN+pIgW7UUSUYyDZjBgzwyxSbnLCW7BDbBY17QuvW3UuxTf8Cz6NGdi5YfYOF2MWbpof5pPE8UbEZwlbc/aQJ+cv2/8Bs9l+Y+mAgeSYEPwBflZ7Bfgnc+3wAD4MZ+ziE5cBa8cP0gFgOIeSOkJwY7gCawW5v0hzzD587OKeuaiHCtv16mh0IrjT4MhwOUvn69hozIKqvU+oNwM7H1LI3iJuCqhSAiCJTKnkCc+gVEHjkR2WqMA8ANV9jZA45ZWn0gAo4p8g2dEDtHvMOil09gUKCdiCcT5eqFxJV9du8AKrEDlSjwVqr3uQ5yJq67kAVfwMNXtjbrUqyfdrKGvWT7V8dNKWsrGL7btnVXPHtdahprUat31pDB5kQ8AwVzGZQ2x1rm6AXUtmD9gMXqid0Clf6mU6qsgD1nXYXTbg4Z9hE2He0MrEudCQfWgoFI0+65eRR9RL9AUykPsZNkqalAAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "whatsup",
    href: "#img1",
    x: 3,
    y: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsup);
export default __webpack_public_path__ + "static/media/whatsup.7b1c513e8e30e37e5ae676b49ad547f2.svg";
export { ForwardRef as ReactComponent };